import React from 'react';
import Text from '../../v2BaseComponents/Text';

export type TimeDisplayOwnProps = {
    position: number;
    duration: number;
    isRemaining?: boolean;
};

const millisecondToTimeDisplay = (millisecond: number): string => {
    const minutes = Math.floor(millisecond / 60000);
    const seconds = Math.floor((millisecond % 60000) / 1000);
    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
};

export type TimeDisplayProps = TimeDisplayOwnProps;

const TimeDisplay: React.FC<TimeDisplayProps> = (props) => {
    const { position, duration, isRemaining } = props;

    const timeMs = Math.max(isRemaining ? duration - position : position, 0);

    return <Text variant="caption-1">{`${isRemaining ? '-' : ''}${millisecondToTimeDisplay(timeMs)}`}</Text>;
};

export default React.memo(TimeDisplay);
